import { render, staticRenderFns } from "./add-composition-modal.vue?vue&type=template&id=0facb7a9&scoped=true&"
import script from "./add-composition-modal.vue?vue&type=script&lang=js&"
export * from "./add-composition-modal.vue?vue&type=script&lang=js&"
import style0 from "./add-composition-modal.vue?vue&type=style&index=0&id=0facb7a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0facb7a9",
  null
  
)

export default component.exports